module.exports = __webpack_public_path__ + "static/media/wirin_thumbnail.15d8fbf6.png";